import { isVisible } from '../../../utils/element/utils';

// ----------------------------------------------------------------------------

function initBackdropStackingEvents(element: any = document): void {
    element.addEventListener('show.bs.modal', function (evt): any {
        handleBackdropStacking(evt.target);
    });
}

function handleBackdropStacking(element: HTMLElement): void {
    let backdropCount: number = 0;

    const listModal = document.querySelectorAll<HTMLElement>('.modal');

    for (const elModal of listModal) {
        if (isVisible(elModal)) {
            backdropCount++;
        }
    }

    const zIndex = 1040 + 10 * backdropCount;

    element.style.zIndex = zIndex.toString();

    setTimeout(function (): any {
        const elModalBackdrop = document.querySelector<HTMLElement>('.modal-backdrop:not(.modal-stack)');

        if (!elModalBackdrop) {
            return;
        }

        elModalBackdrop.classList.add('modal-stack');
        elModalBackdrop.style.zIndex = (zIndex - 1).toString();
    });
}

// ----------------------------------------------------------------------------

export { initBackdropStackingEvents, handleBackdropStacking };
